import {
  IAttachmentConfig,
  configureEmailAttachments,
  renderPendingAttachment,
  getPendingAttachmentCount,
} from '../../components/email_attachments'
import { renderPendingAlert } from '../../components/attachments'

function initInboxCompose() {
  const onFilesAccepted = (files: Array<File>, config: IAttachmentConfig) => {
    files.forEach((file) => {
      renderPendingAttachment(config, file).then(() =>
        renderPendingAlert(getPendingAttachmentCount()),
      )
    })
  }

  configureEmailAttachments(
    {
      renderNoAttachmentPath:
        '/partner/applicants/attachments/render_no_attachment',
      pendingAttachmentPath: '/partner/inbox/render-pending-attachment',
    },
    onFilesAccepted,
  )
}

export { initInboxCompose }
